<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">

    <v-dialog v-model="debugDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Debug</v-card-title>

        <v-card-text>

          <v-row row>
            <v-col>
              Username
            </v-col>
            <v-col>
              {{userinfo.username}}
            </v-col>
          </v-row>

          <v-row row>
            <v-col>
              Email
            </v-col>
            <v-col>
              {{userinfo.email}}
            </v-col>
          </v-row>

          <v-row row>
            <v-col>
              Admin
            </v-col>
            <v-col>
              {{userinfo.is_superuser}}
            </v-col>
          </v-row>

          <v-row row>
            <v-col>
              User type
            </v-col>
            <v-col>
              {{usertype}}
            </v-col>
          </v-row>

        </v-card-text>

      </v-card>
    </v-dialog>

    <v-app-bar app clipped-left dense color="appbar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

<!--
      <v-img v-if="isAdmin" max-height="32" max-width="100" src="@/assets/2019_carnego_logo.png" @click.stop="openDebug"></v-img>
      <v-img v-if="!isAdmin" max-height="32" max-width="100" src="@/assets/2019_carnego_logo.png"></v-img>
-->

      <v-img max-height="32" max-width="100" src="@/assets/2019_carnego_logo.png" @click.stop="refreshPage"></v-img>


      <!-- <v-img max-height="32" max-width="100" src="@/assets/2019_carnego_logo.png"></v-img>
      &nbsp;&nbsp; -->
      <!-- <v-img max-height="32" max-width="100" src="@/assets/Ventive-logo-black_32pxhigh.png"></v-img> -->

      <!-- <v-toolbar-title>Carnego BCP DataViewer</v-toolbar-title> -->

      <!-- <v-spacer></v-spacer>

      <v-btn text v-if="username">
        <v-img style="width: 32px; height: 32px" :src="avatar"></v-img>
        &nbsp; {{username}}
      </v-btn> -->

      <!-- <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="n in 5" :key="n" @click="() => {}">
            <v-list-item-title>Option {{ n }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>-->
    </v-app-bar>

    VUE_APP_AUTH

    <v-navigation-drawer v-model="drawer" clipped-left app temporary>
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar v-if="avatar">
            <!-- <v-img style="width: 32px; height: 32px" :src="avatar"></v-img> -->
            <!-- <v-img style="width: 32px; height: 32px" :src="`${window.VUE_APP_AUTH}${avatar}`"></v-img> -->
            <v-img style="width: 32px; height: 32px" :src="fullAvatarUrl"></v-img>
          </v-list-item-avatar>
          <v-list-item-avatar v-else>
            <v-icon>mdi-face</v-icon>
          </v-list-item-avatar>
        </v-list-item>

        <!-- <v-list-item v-if="isAdmin" link> -->
        <v-list-item link>
          <v-list-item-content>
            <v-select return-object dense v-model="site_group" v-on:change="changeSiteGroup" item-text="namespace" item-value="namespace" :items="site_groups" label="Site Groups"></v-select>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title">{{userinfo.username}}</v-list-item-title>
            <v-list-item-subtitle>{{userinfo.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title @click.stop="logout">Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>

        <v-list-item v-if="userHasApp('performance')" link to="/performance_manager">
          <v-list-item-icon>
            <v-icon>mdi-home-group</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Performance Manager</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="userHasApp('portfolio') && siteHasPortfolio()" link to="/portfolio_manager">
          <v-list-item-icon>
            <v-icon>mdi-home-group</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Portfolio Manager</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="userHasApp('dataviewer')" link to="/bcp">
          <v-list-item-icon>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Data Viewer</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="userinfo.is_superuser" link to="/tagging">
          <v-list-item-icon>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Tagging</v-list-item-title>
        </v-list-item>

        <!-- <v-list-item v-if="userHasApp('dataquality')" link to="/dataquality">
          <v-list-item-icon>
            <v-icon>mdi-database-check</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Data Quality</v-list-item-title>
        </v-list-item> -->

        <v-list-group v-if="userHasApp('shimmyplus') && shimmyPages.length > 0" :value="true" no-action sub-group eager>

          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>ShimmyPlus</v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- id is only used so the menu selection does not hightlight all entries -->
          <v-list-item v-for="page in shimmyPages" :key="page.name" link :to="'/shimmyplus/' + page.id">
            <v-list-item-icon>
              <v-icon>mdi-account-supervisor</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{page.name}}</v-list-item-title>
          </v-list-item>

        </v-list-group>

      </v-list>
    </v-navigation-drawer>

    <!-- Navigation Drawer -->

    <!-- Sizes your content based upon application components -->
    <v-main>
      <router-view class="pa-2" @authenticated="setAuthenticated" />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import Layout from './Layout.vue'; // @ is an alias to /src
import axios from 'axios';
import { carnego_theme } from '@/plugins/vuetify';

@Component({
  components: {},
})
export default class DefaultLayout extends Layout {

  public drawer: any = false;
  public debugDialog: boolean = false;

  public site_group = [];
  public site_groups = [];

  public async mounted() {
    this.theme = carnego_theme;
    this.setUp();
    this.site_groups = this.$store.getters.SiteGroups;
    this.site_group = this.$store.getters.CurrentSiteGroup;
  }

  public openDebug() {
    this.debugDialog = true;
  }

  public get fullAvatarUrl(): string {
    // Assuming avatar is a property in your component
    debugger;
    return window.VUE_APP_AUTH + this.avatar;
  }

  public refreshPage() {
    console.log("window.location.href", window.location.href);

    if (window.location.href.includes("?")) {
        let parts = window.location.href.split("?");
        window.location.href = parts[0] + '?' + new Date().getTime();
    }
    else {
      window.location.href = window.location.href + '?' + new Date().getTime();
    } 
  }

  public closeDrawer(): void {
    this.drawer = false;
  }

  

  

  
}
</script>

<style lang="less">
// body {
//     background-color: #f0f0f0;
// }
// h1 {
//     padding: 0;
//     margin-top: 0;
// }
// #app {
//     margin: 5px;
// }
</style>
